import parseSubjects from './parceSubjects';
import getAcademicYear from './getAcademicYear';
import {
  pluralizeAge,
  pluralizeToPeople,
  pluralizeHours,
} from '@/tools/pluralize';
import isArrayNotEmpty from '@/tools/isarraynotempty';

const toDate = (value: string, a: string, b: string): string => {
  if (!value && typeof value !== 'string') return '';
  return value.slice(0, 10).split(a).reverse().join(b);
};
const fromUtc = (value: string): string => toDate(value, '-', '.');

const mapSubgroupsData = (groups: Array<any>): Array<any> => {
  if (!Array.isArray(groups)) return [];
  return groups.map((group) => {
    const {
      age_from,
      age_to,
      id,
      date_end,
      date_start,
      name,
      order_count,
      size,
      size_min,
      subjects,
      schedule,
      hours_year,
      available_next_year_order_from,
      available_order_current_year,
    } = group;

    const { academic_year_id } = isArrayNotEmpty(schedule)
      ? schedule[0]
      : { academic_year_id: '0' };

    return {
      ...group,
      academicYear: getAcademicYear(schedule),
      academic_year_id,
      available_next_year_order_from: fromUtc(available_next_year_order_from),
      age_from: parseFloat(age_from),
      age_to: parseFloat(age_to),
      ageEqual: age_from === age_to ? pluralizeAge(parseFloat(age_from)) : null,
      name: `${name} (артикул ${id})`,
      date_start: fromUtc(date_start),
      date_end: fromUtc(date_end),
      orderCount:
        order_count === 0 ? 'все места свободны' : `${order_count} занято`,
      canRequest: available_order_current_year,
      size: size === '1' ? 'Индивидуальное обучение' : pluralizeToPeople(size),
      size_max: parseInt(size, 10),
      size_min: parseInt(size_min, 10),
      subjects: parseSubjects(subjects),
      hours_year: pluralizeHours(parseFloat(hours_year)),
    };
  });
};

export default mapSubgroupsData;



// WEBPACK FOOTER //
// ./src/services/subgroups/utils/mapSubgroupsData.ts